import React from "react";

import { IconButton, Tooltip } from "@mui/material";
import { BsInfoCircle } from "react-icons/bs";

import useStyles from "./styles";

type ActionIconButtonProps = {
  children: React.ReactNode;
  tooltipTitle: string;
  disabled?: boolean;
  dataCy?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const ActionIconButton = ({
  children,
  disabled,
  tooltipTitle,
  dataCy,
  onClick,
}: ActionIconButtonProps) => {
  const classes = useStyles();

  const renderTitle = (): JSX.Element => {
    return (
      <div className={classes.tooltip}>
        <BsInfoCircle />

        <span>{tooltipTitle}</span>
      </div>
    );
  };

  return (
    <Tooltip title={renderTitle()}>
      <span>
        <IconButton
          data-cy={dataCy}
          disabled={disabled}
          className={classes.iconButton}
          onClick={onClick}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
};
